import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Button } from '../../../components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/ui/popover';
import { Zap, FileText, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const aplicarVariables = (texto, conv) => {
  const m = conv?.matriculado || {};
  const nombre = m.nombre || conv?.nombre || '';
  return texto.replace(/\{nombre\}/gi, nombre).replace(/\{matricula\}/gi, m.numero_matricula || '');
};

export function CRMRespuestasRapidas({ base, headers, conv, disabled, open, setOpen, filtro, onInsert, pickRef }) {
  const [items, setItems] = useState(null);
  const [cargandoEC, setCargandoEC] = useState(false);

  useEffect(() => {
    if (!open) return;
    axios.get(`${base}/crm/respuestas-rapidas`, { headers }).then(r => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [open, base, headers]);

  const visibles = useMemo(() => {
    const f = (filtro || '').toLowerCase();
    return (items || []).filter(i => !f || i.titulo.toLowerCase().includes(f) || i.texto.toLowerCase().includes(f));
  }, [items, filtro]);

  if (pickRef) pickRef.current = visibles[0] ? () => onInsert(aplicarVariables(visibles[0].texto, conv)) : null;

  const estadoCuenta = async () => {
    setCargandoEC(true);
    try {
      const r = await axios.get(`${base}/crm/estado-cuenta/${encodeURIComponent(conv.phone)}`, { headers, timeout: 120000 });
      onInsert(r.data.texto);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo consultar ANTUAR');
    } finally { setCargandoEC(false); }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="icon" className="shrink-0" disabled={disabled} title="Respuestas rápidas"
          data-testid="crm-btn-respuestas-rapidas"><Zap className="w-4 h-4 text-amber-600" /></Button>
      </PopoverTrigger>
      <PopoverContent align="start" side="top" className="w-80 p-0" data-testid="crm-respuestas-popover"
        onOpenAutoFocus={e => e.preventDefault()}>
        <button type="button" onClick={estadoCuenta} disabled={cargandoEC}
          className="w-full text-left px-3 py-2.5 border-b flex items-center gap-2 hover:bg-amber-50 text-sm font-medium"
          data-testid="crm-respuesta-estado-cuenta">
          {cargandoEC ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4 text-amber-600" />}
          {cargandoEC ? 'Consultando ANTUAR…' : 'Estado de cuenta (consulta ANTUAR)'}
        </button>
        <div className="max-h-64 overflow-y-auto">
          {items === null ? (
            <p className="text-xs text-gray-400 p-3 flex items-center gap-1"><Loader2 className="w-3 h-3 animate-spin" /> Cargando…</p>
          ) : visibles.length === 0 ? (
            <p className="text-xs text-gray-400 p-3">
              {items.length ? 'Sin coincidencias.' : 'Sin respuestas guardadas. Crealas en Config → Respuestas rápidas.'}
            </p>
          ) : visibles.map(i => (
            <button key={i.id} type="button" onClick={() => onInsert(aplicarVariables(i.texto, conv))}
              className="w-full text-left px-3 py-2 border-b hover:bg-amber-50" data-testid={`crm-respuesta-${i.id}`}>
              <p className="text-sm font-medium">{i.titulo}</p>
              <p className="text-xs text-gray-500 line-clamp-2">{i.texto}</p>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
